import {
  SET_ASSET_UPDATE_PLAN,
  RESET_ASSET_UPDATE,
  SET_ASSET_UPDATE_FILE,
  SET_ASSET_UPDATE_MODE,
  SET_ASSET_UPDATE_ERROR,
  SET_IS_APPLYING_ASSET_UPDATE,
  SET_IS_PLANNING_ASSET_UPDATE,
  SET_ASSET_UPDATE_SHOW_CHANGES_ONLY,
} from '../actions/actionTypes';
import { AssetUpdateAction, AssetUpdateStateType } from '../context';

export default (
  state: AssetUpdateStateType,
  action: AssetUpdateAction,
): AssetUpdateStateType => {
  switch (action.type) {
    case SET_ASSET_UPDATE_FILE:
      return {
        ...state,
        fileName: action.payload.name,
        fileContents: action.payload.contents,
      };
    case SET_IS_PLANNING_ASSET_UPDATE:
      return {
        ...state,
        isPlanningAsset: action.payload,
      };
    case SET_ASSET_UPDATE_PLAN: {
      return {
        ...state,
        importTime: new Date(),
        plannedUpdatedAsset: action.payload,
      };
    }
    case SET_IS_APPLYING_ASSET_UPDATE:
      return {
        ...state,
        isApplyingAsset: action.payload,
      };
    case SET_ASSET_UPDATE_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case RESET_ASSET_UPDATE:
      return {
        ...state,
        isPlanningAsset: false,
        isApplyingAsset: false,
        plannedUpdatedAsset: null,
        fileName: null,
        fileContents: null,
      };
    case SET_ASSET_UPDATE_MODE:
      return {
        ...state,
        assetUpdateMode: action.payload,
      };
    case SET_ASSET_UPDATE_SHOW_CHANGES_ONLY:
      return {
        ...state,
        showChangesOnly: action.payload,
      };
    default:
      return state;
  }
};
